import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { hidden: "" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Confirmación de registro")
], -1)
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6" }
const _hoisted_6 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "¡Atención!"),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, " Por favor verifique que todos los datos sean correctos. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dataEdit.state), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
        ]),
        _hoisted_7
      ])
    ])
  ]))
}